import { render, staticRenderFns } from "./cargoInsurance.vue?vue&type=template&id=bdf1212a&"
import script from "./cargoInsurance.vue?vue&type=script&lang=js&"
export * from "./cargoInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf1212a')) {
      api.createRecord('bdf1212a', component.options)
    } else {
      api.reload('bdf1212a', component.options)
    }
    module.hot.accept("./cargoInsurance.vue?vue&type=template&id=bdf1212a&", function () {
      api.rerender('bdf1212a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/cargoInsurance.vue"
export default component.exports